module.exports = __webpack_public_path__ + "media/images/bacterial-label-a2b9ba6dcc589ab1167965cc502056ae.png";